export default __webpack_public_path__ + "static/media/2444_2446.9d7472ed.jpg";